{
    "UserRoleLabel": "Rol:",
    "RoleCustomLabel": "Aangepaste instellingen",
    "RoleRequiresReportingLevel": "Gebruikersrol vereist rapportagetoegang",
    "RoleRequiresNoReportingLevel": "Gebruikersrol vereist geen rapportagetoegang",
    "RolePermissionsTooLow": "U heeft niet voldoende rechten om deze gebruiker te bewerken. Neem contact op met een beheerder om uw rechten te verhogen zodat u deze gebruiker kunt bewerken.",
    "RoleReportingGroup": "RAPPORTERENDE ROLLEN",
    "RoleAdminGroup": "Gebruikersrollen",
    "NONE": "[None]",
    "REPORTING_USER": "Alleen rapporterende gebruiker",
    "ADVANCED_REPORTING_USER": "Geavanceerde rapportagegebruiker",
    "END_USER_ADMIN": "Gebruikersrollen",
    "CUSTOM": "Aangepaste instellingen",
    "SUPER_ADMIN": "Volledige beheerder",
    "RESELLER_ADMIN": "Tussenpersoon",
    "TELEPHONY_SERVER_ADMIN": "Wederverkoper - SP",
    "PARTITION_ADMIN": "Wederverkoper - Site",
    "SUPPORT": "Steun",
    "VIEW": "Volledige beheerder (alleen lezen)",
    "BILLING_SUPPORT": "Facturering",
    "END_USER_PROVISIONING": "Provisioning",
    "SELF_PROVISIONER": "Enterprise Provisioning",
    "Role:NONE": "Er is geen rol toegewezen, deze gebruiker heeft de standaardrechten",
    "Role:REPORTING_USER": "Een rol met rapportagetoegangsniveau en standaardmachtigingen",
    "Role:ADVANCED_REPORTING_USER": "Supervisor met rapportagetoegang en enkele geavanceerde beheerdersacties",
    "Role:END_USER_ADMIN": "Denk aan uniforme rapportage",
    "Role:CUSTOM": "Een aangepaste rol waaraan zo nodig machtigingen worden toegewezen",
    "Role:SUPER_ADMIN": "Denk aan zorgrapportage",
    "Role:RESELLER_ADMIN": "Beheerder met volledige beheerdersrechten, behalve voor het wijzigen van het licentieniveau (en kan optionele rapportagetoegang hebben)",
    "Role:TELEPHONY_SERVER_ADMIN": "Beheerder met volledige beheerdersrechten tot telefonieniveau (en kan optionele rapportagetoegang hebben)",
    "Role:PARTITION_ADMIN": "Beheerder met volledige beheerdersrechten tot partitieniveau (en kan optionele rapportagetoegang hebben)",
    "Role:SUPPORT": "Denk aan zorgrapportage",
    "Role:VIEW": "Beheerder die alleen kan bekijken (en optionele rapportagetoegang kan hebben)",
    "Role:BILLING_SUPPORT": "Beheerder met alleen-lezen-toegang, maar heeft de mogelijkheid om CDR's te downloaden en auditlogboeken te bekijken (en kan optionele rapportagetoegang hebben)",
    "Role:END_USER_PROVISIONING": "Beheerder met de mogelijkheid om in te richten door alleen toe te voegen en te wijzigen (en kan optionele rapportagetoegang hebben)",
    "Role:SELF_PROVISIONER": "Beheerder met de mogelijkheid om in te richten met behulp van de inrichtingswizard (en kan optionele rapportagetoegang hebben)",
    "NAME": "RoleLanguage",
    "UserCustomizedRoles": "AANGEPASTE ROLSJABLONEN",
    "CreateCustomRole": "Aangepast rolsjabloon toevoegen",
    "DeleteCustomRole": "Aangepast rolsjabloon verwijderen",
    "USER_MANAGER": "Gebruikersmanager",
    "Role:USER_MANAGER": "Voor het beheren van gebruikers via het popupvenster Gebruikersbeheer.",
    "Role:TEAMS_PROVISIONING": "Beheerder die telefonieservers kan autoriseren en beheren"
}